export default {
  sendAdhesionContract: 'api/mscotista/send-adhesion-contract',
  findAdhesionContract: 'api/mscotista/get-adhesion-contract',
  signContract: 'api/mscotista/sign-contract'
};
